import { createSlice } from '@reduxjs/toolkit'

export const locationsSlice = createSlice({
    name: 'locations',
    initialState: {
        value: []
    },
    reducers: {
        set: (state, action) => {
            state.value = action.payload;
        },
        unSet: state => {
            state.value = [];
        }
    }
})

// Action creators are generated for each case reducer function
export const { set, unSet } = locationsSlice.actions

export default locationsSlice.reducer